import { useAuthHttp } from '@/composables/api/useAuthHttp'

export function usePublicTicketingApi() {
  const { get, post } = useAuthHttp()

  // GET /api/public/ticketing/groups/{public_key}
  const fetchGroupByKey = async (publicKey: string) => {
    return await get<any>(`/public/ticketing/groups/${publicKey}`)
  }

  const requestLostTickets = async (payload: {
    method: 'email' | 'phone'
    email?: string
    full_phone?: any
  }) => {
    return await post<any>('/public/ticketing/orders/resend', payload)
  }  

  return { fetchGroupByKey, requestLostTickets }
}